/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Funnel_Section_BuildInputs */

const en_admin_funnel_section_build = /** @type {(inputs: Admin_Funnel_Section_BuildInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`By build`)
};

/**
* | output |
* | --- |
* | "By build" |
*
* @param {Admin_Funnel_Section_BuildInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_funnel_section_build = /** @type {((inputs?: Admin_Funnel_Section_BuildInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Funnel_Section_BuildInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_funnel_section_build(inputs)
});
export { admin_funnel_section_build as "admin.funnel.section.build" }